export default [
    {
        name: 'Afghanistan',
        countryCode: 'AF',
    },
    {
        name: 'Ägypten',
        countryCode: 'EG',
    },
    {
        name: 'Anguilla',
        countryCode: 'AI',
    },
    {
        name: 'Albanien',
        countryCode: 'AL',
    },
    {
        name: 'Azoren',
        countryCode: 'PT_20',
    },
    {
        name: 'Ceuta',
        countryCode: 'ES_CE',
    },
    {
        name: 'Kanarische Inseln',
        countryCode: 'IC',
    },
    {
        name: 'Katar',
        countryCode: 'QA',
    },
    {
        name: 'Madeira',
        countryCode: 'PT_30',
    },
    {
        name: 'Martinique',
        countryCode: 'MQ',
    },
    {
        name: 'Mayotte',
        countryCode: 'YT',
    },
    {
        name: 'Melilla',
        countryCode: 'ES_ML',
    },
    {
        name: 'Saint-Barthélemy',
        countryCode: 'BL',
    },
    {
        name: 'Saint-Martin',
        countryCode: 'MF',
    },
    {
        name: 'Nordmazedonien',
        countryCode: 'MK',
    },
    {
        name: 'St. Lucia',
        countryCode: 'LC',
    },
    {
        name: 'St. Kitts',
        countryCode: 'KN',
    },
    {
        name: 'St. Vincent',
        countryCode: 'VC',
    },
    {
        name: 'Andorra',
        countryCode: 'AD',
    },
    {
        name: 'Angola',
        countryCode: 'AO',
    },
    {
        name: 'Antigua & Barbuda',
        countryCode: 'AG',
    },
    {
        name: 'Äquatorialguinea',
        countryCode: 'GQ',
    },
    {
        name: 'Argentinien',
        countryCode: 'AR',
    },
    {
        name: 'Armenien',
        countryCode: 'AM',
    },
    {
        name: 'Aruba',
        countryCode: 'AW',
    },
    {
        name: 'Aserbaidschan',
        countryCode: 'AZ',
    },
    {
        name: 'Äthiopien',
        countryCode: 'ET',
    },
    {
        name: 'Australien',
        countryCode: 'AU',
    },
    {
        name: 'Bahamas',
        countryCode: 'BS',
    },
    {
        name: 'Bahrain',
        countryCode: 'BH',
    },
    {
        name: 'Bangladesch',
        countryCode: 'BD',
    },
    {
        name: 'Barbados',
        countryCode: 'BB',
    },
    {
        name: 'Belgien',
        countryCode: 'BE',
    },
    {
        name: 'Belize',
        countryCode: 'BZ',
    },
    {
        name: 'Bermuda',
        countryCode: 'BM',
    },
    {
        name: 'Bhutan',
        countryCode: 'BT',
    },
    {
        name: 'Bolivien',
        countryCode: 'BO',
    },
    {
        name: 'Bosnien-Herzegowina',
        countryCode: 'BA',
    },
    {
        name: 'Botswana',
        countryCode: 'BW',
    },
    {
        name: 'Brasilien',
        countryCode: 'BR',
    },
    {
        name: 'Britische Jungferninseln',
        countryCode: 'VG',
    },
    {
        name: 'Brunei',
        countryCode: 'BN',
    },
    {
        name: 'Bulgarien',
        countryCode: 'BG',
    },
    {
        name: 'Burkina Faso',
        countryCode: 'BF',
    },
    {
        name: 'Burundi',
        countryCode: 'BI',
        roamingOptionForeignCountry: false,
    },
    {
        name: 'Cayman Inseln',
        countryCode: 'KY',
    },
    {
        name: 'Chile',
        countryCode: 'CL',
    },
    {
        name: 'China',
        countryCode: 'CN',
    },
    {
        name: 'Costa Rica',
        countryCode: 'CR',
    },
    {
        name: 'Curacao (Niederländische Antillen)',
        countryCode: 'CW',
    },
    {
        name: 'Dänemark',
        countryCode: 'DK',
    },
    {
        name: 'Demokratische Republik Kongo',
        countryCode: 'CD',
    },
    {
        name: 'Dominica',
        countryCode: 'DM',
    },
    {
        name: 'Dominikanische Republik',
        countryCode: 'DO',
    },
    {
        name: 'Dschibuti',
        countryCode: 'DJ',
    },
    {
        name: 'Ecuador',
        countryCode: 'EC',
    },
    {
        name: 'El Salvador',
        countryCode: 'SV',
    },
    {
        name: 'Elfenbeinküste',
        countryCode: 'CI',
    },
    {
        name: 'Estland',
        countryCode: 'EE',
    },
    {
        name: 'Färöer Inseln',
        countryCode: 'FO',
    },
    {
        name: 'Fidschi',
        countryCode: 'FJ',
    },
    {
        name: 'Finnland',
        countryCode: 'FI',
    },
    {
        name: 'Frankreich',
        countryCode: 'FR',
    },
    {
        name: 'Französisch Guayana',
        countryCode: 'GF',
    },
    {
        name: 'Französisch Westindische Inseln',
        countryCode: 'TF',
    },
    {
        name: 'Französisch-Polynesien',
        countryCode: 'PF',
    },
    {
        name: 'Gabun',
        countryCode: 'GA',
    },
    {
        name: 'Gambia',
        countryCode: 'GM',
    },
    {
        name: 'Georgien',
        countryCode: 'GE',
    },
    {
        name: 'Ghana',
        countryCode: 'GH',
    },
    {
        name: 'Gibraltar',
        countryCode: 'GI',
    },
    {
        name: 'Griechenland',
        countryCode: 'GR',
    },
    {
        name: 'Grönland',
        countryCode: 'GL',
    },
    {
        name: 'Großbritannien',
        countryCode: 'GB',
    },
    {
        name: 'Guadeloupe',
        countryCode: 'GP',
    },
    {
        name: 'Guam',
        countryCode: 'GU',
    },
    {
        name: 'Guatemala',
        countryCode: 'GT',
    },
    {
        name: 'Guernsey (GB)',
        countryCode: 'GG',
    },
    {
        name: 'Guinea',
        countryCode: 'GN',
    },
    {
        name: 'Guyana',
        countryCode: 'GY',
    },
    {
        name: 'Honduras',
        countryCode: 'HN',
    },
    {
        name: 'Hongkong',
        countryCode: 'HK',
    },
    {
        name: 'Indien',
        countryCode: 'IN',
    },
    {
        name: 'Indonesien',
        countryCode: 'ID',
    },
    {
        name: 'Irak',
        countryCode: 'IQ',
    },
    {
        name: 'Iran',
        countryCode: 'IR',
    },
    {
        name: 'Irland',
        countryCode: 'IE',
    },
    {
        name: 'Island',
        countryCode: 'IS',
    },
    {
        name: 'Isle of Man (GB)',
        countryCode: 'IM',
    },
    {
        name: 'Israel',
        countryCode: 'IL',
    },
    {
        name: 'Italien',
        countryCode: 'IT',
    },
    {
        name: 'Jamaika',
        countryCode: 'JM',
    },
    {
        name: 'Japan',
        countryCode: 'JP',
    },
    {
        name: 'Jemen',
        countryCode: 'YE',
    },
    {
        name: 'Jersey (GB)',
        countryCode: 'JE',
    },
    {
        name: 'Jordanien',
        countryCode: 'JO',
    },
    {
        name: 'Kambodscha',
        countryCode: 'KH',
    },
    {
        name: 'Kamerun',
        countryCode: 'CM',
    },
    {
        name: 'Kanada',
        countryCode: 'CA',
    },
    {
        name: 'Kapverdische Inseln',
        countryCode: 'CV',
    },
    {
        name: 'Kasachstan',
        countryCode: 'KZ',
    },
    {
        name: 'Kenia',
        countryCode: 'KE',
    },
    {
        name: 'Kirgistan',
        countryCode: 'KG',
    },
    {
        name: 'Kolumbien',
        countryCode: 'CO',
    },
    {
        name: 'Kongo (Republik)',
        countryCode: 'CG',
    },
    {
        name: 'Kosovo',
        countryCode: 'XK',
    },
    {
        name: 'Kroatien',
        countryCode: 'HR',
    },
    {
        name: 'Kuba',
        countryCode: 'CU',
    },
    {
        name: 'Kuwait',
        countryCode: 'KW',
    },
    {
        name: 'La Reunion',
        countryCode: 'RE',
    },
    {
        name: 'Laos',
        countryCode: 'LA',
    },
    {
        name: 'Lesotho',
        countryCode: 'LS',
    },
    {
        name: 'Lettland',
        countryCode: 'LV',
    },
    {
        name: 'Libanon',
        countryCode: 'LB',
    },
    {
        name: 'Liberia',
        countryCode: 'LR',
    },
    {
        name: 'Libyen',
        countryCode: 'LY',
    },
    {
        name: 'Liechtenstein',
        countryCode: 'LI',
    },
    {
        name: 'Litauen',
        countryCode: 'LT',
    },
    {
        name: 'Luxemburg',
        countryCode: 'LU',
    },
    {
        name: 'Macau',
        countryCode: 'MO',
    },
    {
        name: 'Madagaskar',
        countryCode: 'MG',
    },
    {
        name: 'Malawi',
        countryCode: 'MW',
    },
    {
        name: 'Malaysia',
        countryCode: 'MY',
    },
    {
        name: 'Malediven',
        countryCode: 'MV',
    },
    {
        name: 'Mali',
        countryCode: 'ML',
    },
    {
        name: 'Malta',
        countryCode: 'MT',
    },
    {
        name: 'Maritime Services',
        countryCode: 'MS',
    },
    {
        name: 'Marokko',
        countryCode: 'MA',
    },
    {
        name: 'Mauretanien',
        countryCode: 'MR',
    },
    {
        name: 'Mauritius',
        countryCode: 'MU',
    },
    {
        name: 'Mexiko',
        countryCode: 'MX',
    },
    {
        name: 'Moldau',
        countryCode: 'MD',
    },
    {
        name: 'Monaco',
        countryCode: 'MC',
    },
    {
        name: 'Mongolei',
        countryCode: 'MN',
    },
    {
        name: 'Montenegro',
        countryCode: 'ME',
    },
    {
        name: 'Mosambik',
        countryCode: 'MZ',
    },
    {
        name: 'Myanmar',
        countryCode: 'MM',
    },
    {
        name: 'Namibia',
        countryCode: 'NA',
    },
    {
        name: 'Nepal',
        countryCode: 'NP',
    },
    {
        name: 'Neukaledonien',
        countryCode: 'NC',
        roamingOptionForeignCountry: false,
    },
    {
        name: 'Neuseeland',
        countryCode: 'NZ',
    },
    {
        name: 'Nicaragua',
        countryCode: 'NI',
    },
    {
        name: 'Niederlande',
        countryCode: 'NL',
    },
    {
        name: 'St. Maarten',
        countryCode: 'AN',
    },
    {
        name: 'Niger',
        countryCode: 'NE',
    },
    {
        name: 'Nigeria',
        countryCode: 'NG',
    },
    {
        name: 'Norfolk Island',
        countryCode: 'NF',
        roamingOptionForeignCountry: false,
    },
    {
        name: 'Norwegen',
        countryCode: 'NO',
    },
    {
        name: 'Oman',
        countryCode: 'OM',
    },
    {
        name: 'Österreich',
        countryCode: 'AT',
    },
    {
        name: 'Pakistan',
        countryCode: 'PK',
    },
    {
        name: 'Palästinensische Autonomiegebiete',
        countryCode: 'PS',
    },
    {
        name: 'Panama',
        countryCode: 'PA',
    },
    {
        name: 'Papua-Neuguinea',
        countryCode: 'PG',
    },
    {
        name: 'Paraguay',
        countryCode: 'PY',
    },
    {
        name: 'Peru',
        countryCode: 'PE',
    },
    {
        name: 'Philippinen',
        countryCode: 'PH',
    },
    {
        name: 'Polen',
        countryCode: 'PL',
    },
    {
        name: 'Portugal',
        countryCode: 'PT',
    },
    {
        name: 'Puerto Rico',
        countryCode: 'PR',
    },
    {
        name: 'Roaming im Flugzeug',
        countryCode: 'RF',
    },
    {
        name: 'Ruanda',
        countryCode: 'RW',
    },
    {
        name: 'Rumänien',
        countryCode: 'RO',
    },
    {
        name: 'Russland',
        countryCode: 'RU',
    },
    {
        name: 'Salomon-Inseln',
        countryCode: 'SB',
    },
    {
        name: 'Sambia',
        countryCode: 'ZM',
    },
    {
        name: 'Samoa',
        countryCode: 'WS',
    },
    {
        name: 'Saudi Arabien',
        countryCode: 'SA',
    },
    {
        name: 'Schweden',
        countryCode: 'SE',
    },
    {
        name: 'Schweiz',
        countryCode: 'CH',
    },
    {
        name: 'Senegal',
        countryCode: 'SN',
    },
    {
        name: 'Serbien',
        countryCode: 'RS',
    },
    {
        name: 'Seychellen',
        countryCode: 'SC',
    },
    {
        name: 'Sierra Leone',
        countryCode: 'SL',
    },
    {
        name: 'Simbabwe',
        countryCode: 'ZW',
    },
    {
        name: 'Singapur',
        countryCode: 'SG',
    },
    {
        name: 'Slowakei',
        countryCode: 'SK',
    },
    {
        name: 'Slowenien',
        countryCode: 'SI',
    },
    {
        name: 'Spanien',
        countryCode: 'ES',
    },
    {
        name: 'Sri Lanka',
        countryCode: 'LK',
    },
    {
        name: 'Südafrika',
        countryCode: 'ZA',
    },
    {
        name: 'Südkorea',
        countryCode: 'KR',
    },
    {
        name: 'Süd-Sudan',
        countryCode: 'SS',
    },
    {
        name: 'Surinam',
        countryCode: 'SR',
    },
    {
        name: 'Swasiland',
        countryCode: 'SZ',
        roamingOptionForeignCountry: false,
    },
    {
        name: 'Tadschikistan',
        countryCode: 'TJ',
    },
    {
        name: 'Taiwan',
        countryCode: 'TW',
    },
    {
        name: 'Tansania',
        countryCode: 'TZ',
    },
    {
        name: 'Thailand',
        countryCode: 'TH',
    },
    {
        name: 'Togo',
        countryCode: 'TG',
    },
    {
        name: 'Tonga',
        countryCode: 'TO',
    },
    {
        name: 'Trinidad und Tobago',
        countryCode: 'TT',
    },
    {
        name: 'Tschad',
        countryCode: 'TD',
    },
    {
        name: 'Tschechien',
        countryCode: 'CZ',
    },
    {
        name: 'Tunesien',
        countryCode: 'TN',
    },
    {
        name: 'Türkei',
        countryCode: 'TR',
    },
    {
        name: 'Turkmenistan',
        countryCode: 'TM',
    },
    {
        name: 'Turks & Caicosinseln',
        countryCode: 'TC',
    },
    {
        name: 'Uganda',
        countryCode: 'UG',
    },
    {
        name: 'Ukraine',
        countryCode: 'UA',
    },
    {
        name: 'Ungarn',
        countryCode: 'HU',
    },
    {
        name: 'Uruguay',
        countryCode: 'UY',
    },
    {
        name: 'USA',
        countryCode: 'US',
    },
    {
        name: 'Usbekistan',
        countryCode: 'UZ',
    },
    {
        name: 'Vanuatu',
        countryCode: 'VU',
    },
    {
        name: 'Venezuela',
        countryCode: 'VE',
    },
    {
        name: 'Verein. Arab. Emirate',
        countryCode: 'AE',
    },
    {
        name: 'Vietnam',
        countryCode: 'VN',
    },
    {
        name: 'Weißrussland',
        countryCode: 'BY',
    },
    {
        name: 'Zypern',
        countryCode: 'CY',
    },
    {
        name: 'Guinea-Bissau',
        countryCode: 'GNB',
    },
    {
        name: 'Zentralafrikanische Republik',
        countryCode: 'CF',
    },
    {
        name: 'Kiribati',
        countryCode: 'KI',
    },
];
